import { chatClient } from "@/api/grpc";
import { useAuthedRpc } from "@/hooks/common";
import { makeTripPath } from "@/lib/proto";
import { create } from "@bufbuild/protobuf";
import { ThreadSchema } from "@generated/proto/model";
import { CreateThreadRequestSchema } from "@generated/proto/service";

export function useCreateThread() {
  const { run, loading, error } = useAuthedRpc(
    async (
      user,
      tripId: string,
      thread: Partial<import("@generated/proto/model").Thread>
    ) => {
      if (!tripId?.trim()) throw new Error("tripId is required.");

      const request = create(CreateThreadRequestSchema, {
        tripPath: makeTripPath(user.uid, tripId),
        thread: create(ThreadSchema, thread as any),
      });

      return await chatClient.createThread(request as any);
    }
  );

  return { createThread: run, loading, error };
}
